import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { InstagramCTA } from "@/components/InstagramCTA";
import { Services } from "@/components/Services";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";

export default function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero sub={content?.hero_sub} />
      <Marquee />
      <About />
      <Gallery />
      <InstagramCTA />
      <Services services={content?.services} notice={content?.notice} />
      <Booking />
      <Contact />
      <Footer />
    </main>
  );
}
